export const styles = {
  container: {
    height: '88vh',
    overflow: 'scroll',
    padding: '20px',
    paddingBottom: '100px',
  },
  titleWrapper: {
    width: 'fitContent',
    marginBottom: '55px',
  },
  titleContainer: {
    width: '90%',
    textAlign: 'left',
    margin: 'auto',
    fontSize: '1.5rem',
    fontWeight: '500',
    lineHeight: '1.6',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filtersWrapper: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '90%',
    margin: 'auto',
  },
  filtersContainer: {
    display: 'flex',
    marginRight: 'auto',
    gap: '15px',
  },
  tableContainer: {
    width: '90%',
    margin: 'auto',
  },
  heading: {
    textAlign: 'left',
    paddingTop: '25px',
    width: '90%',
    margin: 'auto',
  },
  noDataContainer: {
    display: 'flex',
    justifyContent: 'center',
    height: '400px',
  },
  toggleButton: (isActive) => ({
    background: isActive ? 'black' : '#fafafa',
    color: isActive ? 'white' : 'black',
    textTransform: 'capitalize',
    borderColor: 'black',
    height: '40px',
  }),
  shimmerComponentUpdatedStyle: {
    width: '90%',
    height: '100%',
    backgroundSize: '2000px 800px',
    border: '0px',
    margin: 'auto',
    padding: '0 20px',
  },
};
